import { EntityStatus, IFieldGroupBuilt, IFieldTypes } from "../../typings";

export const PROJECT_BASIC_INFO_SECTION: IFieldGroupBuilt = {
  name: "basic-info",
  label: "Basic Info",
  min: 1,
  max: 1,
  disabled: false,
  hidden: false,
  headless: false,
  hideBreadCrumb: false,
  fields: [
    {
      fieldType: IFieldTypes.textField,
      name: "name",
      span: 1,
      label: "Job Name",
      labelPlacement: "inline",
      required: true,
      readonly: false,
      autoFocus: false,
      hidden: false,
    },
    {
      fieldType: IFieldTypes.select,
      name: "status",
      span: 1,
      label: "Status",
      labelPlacement: "inline",
      required: true,
      readonly: false,
      autoFocus: false,
      hidden: false,
      options: [
        { value: EntityStatus.active, label: "Active" },
        { value: EntityStatus.inactive, label: "Inactive" },
      ],
    },
    {
      fieldType: IFieldTypes.textField,
      name: "description",
      span: 2,
      label: "Description",
      labelPlacement: "inline",
      required: false,
      readonly: false,
      autoFocus: false,
      hidden: false,
    },
  ],
};
